export { SECURITY_GROUP_ADMIN } from '@m3-tech/boss-types'

export const SECURITY_GROUP_QA_TESTING = 10040
export const SECURITY_GROUP_FEATURE_ADMIN = 96033
export const SECURITY_GROUP_ONESPAN_ESIGN_LAYOUTS = 96048
export const SECURITY_GROUP_TL_REVENUE_SETTING = 96053
/**
 * Payroll Manager — the only group the Business Central "Transactions to review"
 * API answers (`/api/BCNeedsAttention`, FF-2856). boss-types exports the
 * Payroll Manager *Admin* group (96044), not this one.
 */
export const SECURITY_GROUP_PAYROLL_MANAGER = 96001
